var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ods-steps",class:[
     !_vm.simple && 'ods-steps--' + _vm.direction,
     _vm.simple && 'ods-steps--simple',
     _vm.dots && 'ods-steps--dots'
   ],attrs:{"data-name":"OdsSteps"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }